import {
  AccessTimeFilled,
  Delete,
  Edit,
  FilterAltOutlined,
  LockReset,
  Person,
  PersonAddAlt1Outlined,
  PersonOff,
  Settings,
} from "@mui/icons-material";
import {
  Alert,
  Avatar,
  Chip,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Paper,
  Skeleton,
  Snackbar,
  Tooltip,
  Typography,
} from "@mui/material";
import { Box, useTheme } from "@mui/system";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import DatagridComponent from "../../../../../components/datagridComponent/index";
import InternoModalConfirmacaoSaida from "../../../../../components/modalSaindoDaPagina";
import api from "../../../../../services/api";
import ModalAddUserCliente from "../../../../client/5.0-administracao/ModalAddUserCliente";
import ModalEditSenha from "./ModalEditSenha";
import ModalEditUser from "./ModalEditUser";
import useStyles from "./styles";
import { temErp } from "../../../../../services/erpSistema";

// Texto longo: corta com reticências e mostra completo no tooltip.
// (a classe centered-cell usa flex, o que desliga a reticência padrão)
const textoComReticencias = (texto) => (
  <Tooltip title={texto || ""} placement="top">
    <Box
      component="span"
      sx={{
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      }}
    >
      {texto}
    </Box>
  </Tooltip>
);

export default function Staff(params) {
  const {
    openFilter,
    setOpenFilter,
    buscarUsuario,
    setBuscarUsuario,
    setOpenModalAddUser,
    openModalAddUser,
  } = params;
  const [users, setUsers] = useState([]);
  /*   const [buscarUsuario, setBuscarUsuario] = useState(""); */
  const [snackbar, setSnackbar] = useState(null);
  const [permissoes, setPermissoes] = useState([]);
  const [gruposCliente, setGruposCliente] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  /*   const [openFilter, setOpenFilter] = useState(false); */
  const [selectedRow, setSelectedRow] = useState({});
  const [openModalEditUser, setOpenModalEditUser] = useState(false);
  const [openModalEditSenha, setOpenModalEditSenha] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  /*   const [openModalAddUser, setOpenModalAddUser] = useState(false); */
  const [createButton, setCreateButton] = useState(false);
  const [clientes, setClientes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [usersErp, setUsersErp] = useState([]);
  const [newUser, setNewUser] = useState({
    login: "",
    email: "",
    senha: "",
  });
  const [userEdit, setUserEdit] = useState({
    id: "",
    nome: "",
    sobrenome: "",
    login: "",
    email: "",
    status: "",
    foto: "",
  });
  const [selectedCliente, setSelectedCliente] = useState([]);
  const [selectedGrupos, setSelectedGrupos] = useState([]);
  const [loadingUsersErp, setLoadingUsersErp] = useState(false);
  const [isClientesPermitidos, setIsClientesPermitidos] = useState(false);
  const theme = useTheme();
  const styles = useStyles(theme);
  const open = Boolean(anchorEl);
  // Vínculo com usuário e grupos de cliente: só a HubSoft tem (aparece se o
  // sistema tiver HubSoft, mesmo com outros ERPs).
  const temHubsoft = temErp("HUBSOFT");

  const deleteBody =
    "O usuário será excluido permanentemente. Deseja realmente excluir o usuário?";
  const confirmDelete = "Excluir";
  const filteredRows = users?.filter((row, index) => {
    row.numero = index;

    return (
      row.login?.toLowerCase()?.includes(buscarUsuario?.toLowerCase()) ||
      row.nome?.toLowerCase()?.includes(buscarUsuario?.toLowerCase()) ||
      row.email?.toLowerCase()?.includes(buscarUsuario?.toLowerCase()) ||
      row.sobrenome?.toLowerCase()?.includes(buscarUsuario?.toLowerCase()) ||
      row.codigoPermissao?.toLowerCase()?.includes(buscarUsuario?.toLowerCase())
    );
  });

  useEffect(() => {
    getUserClient();
    getPermissoes();
    getAllClientes();
    getUserErp();
    getGruposClientes();
  }, []);

  const getUserErp = async () => {
    setLoadingUsersErp(true);
    try {
      const response = await api.get("/interno/findUserErp");
      setUsersErp(Array.isArray(response?.data) ? response.data : []);
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingUsersErp(false);
    }
  };

  const getUserClient = async () => {
    setLoading(true);
    try {
      const response = await api.get("/interno/findUser");

      setUsers(response?.data);
    } catch (error) {
      setSnackbar({
        children: "Error: Não foi possivel se conectar ao servidor",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  const getAllClientes = async () => {
    setLoading(true);
    try {
      const response = await api.get("/interno/getClients");

      setClientes(response?.data);
    } catch (error) {
      setSnackbar({
        children: "Error: Não foi possivel se conectar ao servidor",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  const deleteUserClient = async (idUser) => {
    setLoadingDelete(true);
    try {
      const response = await api.post("/interno/deleteUser", {
        idUser: idUser,
      });
      setOpenDeleteModal(false);
      const usersInterno = users.filter((user) => user?.id !== idUser);
      setUsers(usersInterno);

      setSnackbar({
        children: "Usuário excluído com sucesso!",
        severity: "success",
      });
    } catch (error) {
      setSnackbar({
        children: "Error: Não foi possivel se conectar ao servidor",
        severity: "error",
      });
    } finally {
      setLoadingDelete(false);
    }
  };
  const createUserCliente = async () => {
    try {
      let permissaoId = permissoes.filter(
        (permissao) => permissao?.codigoPermissao === newUser?.permissao,
      );

      const response = await api.post("/interno/createUser", {
        login: newUser?.login,
        senha: newUser?.senha,
        email: newUser?.email,
        permissaoId: (Array.isArray(permissaoId) && permissaoId[0]?.id) || "",
        clientesPermitidos: isClientesPermitidos
          ? newUser?.clientesPermitidos?.map((item) => item?.id) || []
          : [],
        userErpId: newUser?.userErpId || null,
        gruposCliente: isClientesPermitidos ? newUser?.gruposCliente || [] : [],
      });

      setOpenModalAddUser(false);

      setUsers((prev) => [
        ...prev,
        {
          ...response?.data,
          permissoes: { permissaoId: permissaoId[0]?.id } || "",
          clientesPermitidos: isClientesPermitidos
            ? newUser?.clientesPermitidos || []
            : [],
        },
      ]);
      setNewUser({
        login: "",
        email: "",
        senha: "",
        permissao: "",
      });
      setSnackbar({
        children: "Usuário criado com sucesso!",
        severity: "success",
      });
    } catch (error) {
      let menssegeErro = error?.response?.data.error;
      if (menssegeErro === "Email already exists!") {
        setSnackbar({
          children: "E-mail existente",
          severity: "error",
        });
      } else if (menssegeErro === "User already exists!") {
        setSnackbar({
          children: "Usuário existente",
          severity: "error",
        });
      } else {
        setSnackbar({
          children: "Error: Não foi possivel se conectar ao servidor",
          severity: "error",
        });
      }
    } finally {
      setCreateButton(false);
    }
  };
  async function getPermissoes() {
    try {
      const response = await api.get("/interno/getPermissoes");

      setPermissoes(response?.data);
    } catch (error) {
      console.error("Erro ao puxar permissões");
    } finally {
    }
  }

  async function getGruposClientes() {
    try {
      const response = await api.get("/interno/getGruposClientes");

      setGruposCliente(response?.data);
    } catch (error) {
      console.error("Erro ao puxar permissões");
    } finally {
    }
  }

  const handleClose = () => {
    setAnchorEl(null);
  };

  const columns = [
    {
      field: "avatar",
      headerName: "",
      maxWidth: 50,
      minWidth: 50,
      flex: 1,
      sortable: false,

      renderCell: (params) => {
        const foto = params?.row?.foto ? params?.row?.foto : "";
        return (
          <Box>
            <Avatar
              sx={styles.containerAvatar}
              alt={params.row.foto ? params.row.nome : ""}
              src={foto ? foto : "/"}
            />
          </Box>
        );
      },
    },
    {
      field: "login",
      headerName: "Login",
      width: 60,
      minWidth: 100,
      flex: 1,
      cellClassName: "centered-cell",
      renderCell: (params) => textoComReticencias(params?.value),
    },
    {
      field: "nome",
      headerName: "Nome",
      minWidth: 100,
      width: 80,
      flex: 1,
      cellClassName: "centered-cell",
      renderCell: (params) => {
        return textoComReticencias(
          `${params?.row?.nome || ""} ${params?.row?.sobrenome || ""}`,
        );
      },
    },
    {
      field: "email",
      headerName: "E-mail",
      width: 60,
      minWidth: 120,
      flex: 1,
      cellClassName: "centered-cell",
      valueGetter: (params) => {
        return `${params || ""}`;
      },
      renderCell: (params) => textoComReticencias(params?.value),
    },
    {
      field: "permissoes",
      headerName: "Permissões",
      width: 40,
      minWidth: 120,
      flex: 1,
      cellClassName: "centered-cell",
      valueGetter: (params) => {
        return params?.permissaoId;
      },
      renderCell: (params) => {
        return (
          <>
            {params?.row?.permissoes?.permissaoId ? (
              Array.isArray(permissoes) &&
              permissoes
                ?.filter(
                  (permissao) =>
                    permissao?.id === params?.row?.permissoes?.permissaoId,
                )
                ?.map((perm, index) => (
                  <Tooltip title={perm?.codigoPermissao?.toUpperCase()}>
                    <Chip
                      key={index}
                      size="small"
                      label={perm?.codigoPermissao?.toUpperCase()}
                      sx={
                        perm?.codigoPermissao?.toUpperCase() === "ADM"
                          ? {
                              ...styles.chipPermissoes,
                              backgroundColor: "chip.main.waitingReview",
                            }
                          : {
                              ...styles.chipPermissoes,
                              backgroundColor:
                                perm?.color || theme.palette.colors.gray.medium,
                            }
                      }
                    />
                  </Tooltip>
                ))
            ) : (
              <Box sx={styles.conatinerChip}>
                <Tooltip title={"SEM PERMISSÃO"}>
                  <Chip
                    label={"SEM PERMISSÃO"}
                    size="small"
                    sx={{
                      ...styles.chipPermissoes,
                      backgroundColor: "chip.main.arquive",
                    }}
                  />
                </Tooltip>
              </Box>
            )}
          </>
        );
      },
    },
    {
      field: "countClientes",
      headerName: "Clientes permitidos",
      width: 60,
      minWidth: 120,
      flex: 1,
      cellClassName: "centered-cell",
      valueGetter: (params, row) => {
        const countClientesPermitidos = params;
        const countGruposClientes = row?.gruposCliente?.length;

        const countClientes = params;
        const count =
          countClientes === 0 && countGruposClientes > 0
            ? 0
            : countClientes === 0 && countGruposClientes === 0
              ? "Todos"
              : countClientes;
        return `${count}`;
      },
    },
    ...(temHubsoft
      ? [
          {
            field: "userErpId",
            headerName: "Usuário HubSoft",
            minWidth: 160,
            flex: 1,
            renderCell: (params) => {
              // Se estiver carregando, exibe o Skeleton
              if (loadingUsersErp) {
                return (
                  <Box
                    sx={{
                      ...styles.containerUserErp,
                    }}
                  >
                    <Skeleton
                      variant="rounded"
                      width="100%"
                      height={24}
                      animation="wave"
                    />
                  </Box>
                );
              }

              const userErp = usersErp?.find(
                (user) =>
                  user?.id?.toString() === params?.row?.userErpId?.toString(),
              );

              const nomeUsuario = userErp?.name;

              return (
                <Box sx={styles.containerUserErp}>
                  {nomeUsuario ? (
                    <Tooltip title={nomeUsuario} arrow placement="top">
                      <Chip
                        label={nomeUsuario}
                        variant="outlined"
                        size="small"
                        sx={styles.chipUserErp}
                      />
                    </Tooltip>
                  ) : (
                    <Typography variant="caption" color="text.secondary">
                      -
                    </Typography>
                  )}
                </Box>
              );
            },
          },
        ]
      : []),
    {
      field: "status",
      headerName: "Status",
      width: 40,
      minWidth: 70,
      flex: 1,
      valueGetter: (params) => {
        return params;
      },
      renderCell: (params) => {
        return (
          <>
            {params?.row?.status === 1 && params?.row?.ultimoAcesso ? (
              <Box sx={styles.containerPrimeiroAcesso}>
                <Tooltip title="Perfil ativo">
                  <Person sx={styles.person} />
                </Tooltip>
              </Box>
            ) : !params?.row?.status ? (
              <Box sx={styles.containerPrimeiroAcesso}>
                <Tooltip title="Perfil desativado">
                  <PersonOff
                    sx={{ color: theme.palette.chip.colorText.critical }}
                  />
                </Tooltip>
              </Box>
            ) : params?.row?.status === 1 && !params?.row?.ultimoAcesso ? (
              <Box sx={styles.containerPrimeiroAcesso}>
                <Tooltip title="Aguardando primeiro login">
                  <Box>
                    <Person sx={styles.personOff} />
                    <AccessTimeFilled sx={styles.containerIconTime} />
                  </Box>
                </Tooltip>
              </Box>
            ) : (
              <></>
            )}
          </>
        );
      },
    },
    {
      field: "ultimoAcesso",
      headerName: "Último Acesso",
      width: 60,
      minWidth: 120,
      flex: 1,
      type: "dataTime",
      cellClassName: "centered-cell",
      valueGetter: (params) => {
        return (params?.createAt && dayjs(params?.createAt).toDate()) || "";
      },
      renderCell: (params) => {
        return (
          params?.row?.ultimoAcesso?.createAt &&
          dayjs(params?.row?.ultimoAcesso?.createAt).format("DD/MM/YYYY HH:mm")
        );
      },
    },

    {
      field: "detalhes",
      headerName: "Detalhes",
      maxWidth: 90,
      minWidth: 90,
      flex: 1,
      sortable: false,

      renderCell: (params) => {
        return (
          <Tooltip title="Visualizar perfil">
            <IconButton
              onClick={(event) => {
                setAnchorEl(event.currentTarget);
                setSelectedRow(params.row);
              }}
              id="basic-button"
              disabled={
                JSON.parse(localStorage.getItem("user"))?.usuario?.id ===
                params.row.id
              }
              sx={{
                // display: "flex",
                // alignItems: "center",
                height: "35px",
                width: "35px",
              }}
            >
              <Settings
                mode="view"
                params={params}
                sx={{
                  color:
                    JSON.parse(localStorage.getItem("user"))?.usuario?.id ===
                    params.row.id
                      ? theme.palette.mode === "dark"
                        ? "chip.main.arquive"
                        : "disabled.main"
                      : theme.palette.mode === "dark"
                        ? "disabled.main"
                        : "chip.main.arquive",
                }}
              />
            </IconButton>
          </Tooltip>
        );
      },
    },
  ];
  const actions = [
    {
      icon: <FilterAltOutlined />,
      name: "Filtro",
      onClick: () => setOpenFilter(true),
    },
    {
      icon: <PersonAddAlt1Outlined />,
      name: "Novo Usuário Cliente",
      onClick: () => setOpenModalAddUser(true),
    },
  ];
  return (
    <Box sx={styles.container}>
      {/* <FilterBar
				actions={actions}
				openFilter={openFilter}
				setOpenFilter={setOpenFilter}
				selectorComponentLeft={
					<TextField
						variant="outlined"
						label="Buscar usuário"
						value={buscarUsuario}
						size="small"
						onChange={(event) => {
							setBuscarUsuario(event.target.value);
						}}
						InputProps={{
							startAdornment: (
								<InputAdornment position="start">
									<Search />
								</InputAdornment>
							),
							endAdornment: buscarUsuario ? (
								<InputAdornment position="end">
									<IconButton onClick={() => setBuscarUsuario("")} edge="end">
										<Clear />
									</IconButton>
								</InputAdornment>
							) : null,
						}}
						sx={styles.searcField}
					/>
				}
				selectorComponentRight={
					<Button
						endIcon={<Add sx={styles.containerAdd} />}
						onClick={() => setOpenModalAddUser(true)}
						sx={styles.buttomAddUser}
						variant="outlined"
					>
						Novo Usuário
					</Button>
				}
			/> */}
      <Paper
        sx={{
          ...styles.paper,
          ...(filteredRows?.length > 16 && { height: "500px" }),
        }}
        elevation={theme.palette.mode === "dark" ? 0 : 3}
      >
        <Box
          sx={{
            display: "flex",
            ...(filteredRows?.length > 16 && { height: "445px" }),
          }}
        >
          <DatagridComponent
            rows={filteredRows}
            columns={columns}
            // options={{ autoHeight: true }}
            sxDatagrid={{
              "& .MuiDataGrid-row": {
                height: 40,
              },
              "& .centered-cell": {
                display: "flex",
                alignItems: "center",
              },
            }}
            // rowsPerPageOptions={[25, 50, 100]}
            // autoHeight={true}
            // pageSizeOptions={[25, 50, 100]}
            // initialState={{
            // 	pagination: {
            // 		paginationModel: { page: 1, pageSize: 25 },
            // 	},
            // }}
            // disableRowSelectionOnClick
            // sx={styles.dataGrid}
            // disableColumnMenu
            // loading={loading}
          />
        </Box>
      </Paper>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        disableScrollLock={true}
      >
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            setOpenModalEditUser(true);
          }}
        >
          <ListItemIcon>
            <Edit />
          </ListItemIcon>
          <ListItemText>Editar</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            setOpenModalEditSenha(true);
          }}
        >
          <ListItemIcon>
            <LockReset />
          </ListItemIcon>
          <ListItemText>Alterar Senha</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setOpenDeleteModal(true);
            setAnchorEl(null);
          }}
          disabled={loadingDelete}
        >
          <ListItemIcon sx={{ color: "error.main" }}>
            <Delete />
          </ListItemIcon>
          <ListItemText sx={{ color: "error.main" }}>Excluir</ListItemText>
        </MenuItem>
      </Menu>
      <InternoModalConfirmacaoSaida
        openConfirmacao={openDeleteModal}
        load={loadingDelete}
        setOpenConfirmacao={setOpenDeleteModal}
        execute={() => {
          deleteUserClient(selectedRow?.id);
        }}
        severity={"error"}
        title="Atenção"
        headerText={`Esta ação não pode ser desfeita. `}
        contentText={`O usuário ${selectedRow?.login} será removido do sistema. Deseja prosseguir ?`}
        confirmText={confirmDelete}
      />
      <ModalAddUserCliente
        open={openModalAddUser}
        setOpenModalAddUser={setOpenModalAddUser}
        setNewUserClient={setNewUser}
        createUserCliente={createUserCliente}
        createButton={createButton}
        newUserCliente={newUser}
        setSnackbar={setSnackbar}
        permissoes={permissoes}
        clientes={clientes}
        isInterno={true}
        setSelectedCliente={setSelectedCliente}
        selectedCliente={selectedCliente}
        setIsClientesPermitidos={setIsClientesPermitidos}
        isClientesPermitidos={isClientesPermitidos}
        usersErp={usersErp}
        gruposCliente={gruposCliente}
        setSelectedGrupos={setSelectedGrupos}
        selectedGrupos={selectedGrupos}
      />
      <ModalEditUser
        openModalEditUser={openModalEditUser}
        setOpenModalEditUser={setOpenModalEditUser}
        selectedRow={selectedRow}
        setUserEdit={setUserEdit}
        userEdit={userEdit}
        idCliente={""}
        setSnackbar={setSnackbar}
        snackbar={snackbar}
        setUserCliente={setUsers}
        userCliente={users}
        permissoes={permissoes}
        clientes={clientes}
        usersErp={usersErp}
        gruposCliente={gruposCliente}
      />
      <ModalEditSenha
        openModalEditSenha={openModalEditSenha}
        setOpenModalEditSenha={setOpenModalEditSenha}
        selectedRow={selectedRow}
        userEdit={userEdit}
        setSnackbar={setSnackbar}
        snackbar={snackbar}
      />
      {!!snackbar && (
        <Snackbar
          open
          onClose={() => setSnackbar(null)}
          autoHideDuration={2500}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert {...snackbar} onClose={() => setSnackbar(null)} />
        </Snackbar>
      )}
    </Box>
  );
}
